const ru = {
  found: 'найден',
  item: 'результат',
  popup: 'Введите название искажения, часть его описания или примера',
  placeholder: 'Поиск',
  placeholderFull: 'Поиск Искажений',
};

export default ru;
